import { render, staticRenderFns } from "./ComparaitiveGroupBuilder.vue?vue&type=template&id=43518052&scoped=true"
import script from "./ComparaitiveGroupBuilder.vue?vue&type=script&lang=js"
export * from "./ComparaitiveGroupBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43518052",
  null
  
)

export default component.exports